import { render, staticRenderFns } from "./ToDoTable.vue?vue&type=template&id=89b153f0&"
import script from "./ToDoTable.vue?vue&type=script&lang=js&"
export * from "./ToDoTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports